import { useEffect, useSyncExternalStore } from 'react';
import { getBanners, hideBanner, showBanner, subscribeBanners, type BannerMessage } from '@/lib/global-banner';

/**
 * Show `message` in the global banner while the calling component is mounted
 * and the message is non-null; it is removed on unmount, when it turns null,
 * or when its id changes. Safe to call with a fresh object on every render:
 * an unchanged message does not notify the banner.
 */
export function useBanner(message: BannerMessage | null): void {
  const id = message?.id ?? null;

  useEffect(() => {
    if (message) showBanner(message);
  });

  useEffect(() => {
    if (!id) return;
    return () => hideBanner(id);
  }, [id]);
}

/** Visible global-banner messages, most important first. */
export function useBanners(): readonly BannerMessage[] {
  return useSyncExternalStore(subscribeBanners, getBanners, getBanners);
}
